<template>
  <div class="Pamerdatahies">
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.message }}
    </v-snackbar>

    <v-card style="margin-top: 250px">
    <v-breadcrumbs :items="item">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          :href="goToRoute(item.href)"
          :disabled="item.disabled"
        >
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        {{ $t("papardataekport") }} {{ title }}
      </v-card-title>
      <v-container>
        <v-form ref="formcariexport">
          <v-row>
            <v-col cols="12" sm="6">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('negeri')"
                :items="lookupnegeri"
                item-text="negeri"
                item-value="negeriID"
                v-model="paparnegeriexport"
                :disabled="disablenegeri"
                v-on:change="paparlookupjadual"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('jadual')"
                return-object
                :items="jadual"
                item-text="nama"
                v-model="paparjadual"
                v-on:change="paparexport"
                :disabled="disablejadual"
                ref="fokuspaparjadual"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                outlined
                dense
                v-bind:label="$t('pusingan')"
                return-object
                :items="lookuppusingan"
                :item-text="item => item.pusingan"
                v-model="paparpusinganexport"
                v-on:change="cari"
                item-disabled="disable"
                :disabled="disablepusingan"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
        <v-data-table
        v-show="papardatakosong"
        :headers="headers"
        :items-per-page="5"
        class="elevation-1"
      ></v-data-table>
        <Exportblok3
          v-show="paparexportblok3"
          v-bind:papardatablk3="papardatablk3"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exportblok3>
        <Exportbatch
          v-show="paparexportbatch"
          v-bind:papardatabatch="papardatabatch"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exportbatch>
        <Exportjr2
          v-show="paparexportjr2"
          v-bind:papardatajr2="papardatajr2"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exportjr2>
        <Exportjr5
          v-show="paparexportjr5"
          v-bind:papardatajr5="papardatajr5"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exportjr5>
        <Exportjre
          v-show="paparexportjre"
          v-bind:papardatajre="papardatajre"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exportjre>
        <Exportblk4a
          v-show="paparexportblk4a"
          v-bind:papardatablk4a="papardatablk4a"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exportblk4a>
        <Exportblk4b
          v-show="paparexportblk4b"
          v-bind:papardatablk4b="papardatablk4b"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exportblk4b>
        <Exportblk4c
          v-show="paparexportblk4c"
          v-bind:papardatablk4c="papardatablk4c"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exportblk4c>
        <Exportblk7imbgan
          v-show="paparexportblk7imbgan"
          v-bind:papardatablk7imbgn="papardatablk7imbgn"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exportblk7imbgan>
        <Exporthk1
          v-show="paparexporthk1"
          v-bind:papardatahk1="papardatahk1"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exporthk1>
        <Exporthk2
          v-show="paparexporthk2"
          v-bind:papardatahk2="papardatahk2"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exporthk2>
        <Exporthk3
          v-show="paparexporthk3"
          v-bind:papardatahk3="papardatahk3"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exporthk3>
        <Exporthk4
          v-show="paparexporthk4"
          v-bind:papardatahk4="papardatahk4"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exporthk4>
        <Exporthk5
          v-show="paparexporthk5"
          v-bind:papardatahk5="papardatahk5"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exporthk5>
        <Exporthk6
          v-show="paparexporthk6"
          v-bind:papardatahk6="papardatahk6"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exporthk6>
        <Exporthk7
          v-show="paparexporthk7"
          v-bind:papardatahk7="papardatahk7"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exporthk7>
        <Exporthk8
          v-show="paparexporthk8"
          v-bind:papardatahk8="papardatahk8"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exporthk8>
         <!-- <ExportPER9
          v-show="paparexportPER9"
          v-bind:papardataPER9="papardataPER9"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></ExportPER9>
        <Exportperbelanjaan
          v-show="paparexportperbelanjaan"
          v-bind:papardataperbelanjaan="papardataperbelanjaan"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exportperbelanjaan> -->
        <Exportfoodwaste
          v-show="paparexportfoodwaste"
          v-bind:papardatafoodwaste="papardatafoodwaste"
          v-bind:exportthn = "exportthn"
          v-bind:exportbln = "exportbln"
          v-bind:exportps = "exportps"
          v-bind:paparnegeriexport="paparnegeriexport"
        ></Exportfoodwaste>
      </v-container>
    </v-card>
    </v-card>
  </div>
</template>
<script>
import i18n from "@/i18n";
import axios from "../../plugins/axios";
import hidServices from "@/services/lookupField";
const negerilookup = new hidServices();
import getPusingan from "@/services/pusingan";
const pusingan = new getPusingan();
import Exportblok3 from "@/components/Paparexport/exportblk3";
import Exportbatch from "@/components/Paparexport/exportbatch";
import Exportjr2 from "@/components/Paparexport/exportjr2";
import Exportjr5 from "@/components/Paparexport/exportjr5";
import Exportjre from "@/components/Paparexport/exportjre";
import Exportblk4a from "@/components/Paparexport/exportblk4a";
import Exportblk4b from "@/components/Paparexport/exportblk4b";
import Exportblk4c from "@/components/Paparexport/exportblk4c";
import Exportblk7imbgan from "@/components/Paparexport/exportblk7imbgan";
import Exporthk1 from "@/components/Paparexport/exporthk1";
import Exporthk2 from "@/components/Paparexport/exporthk2";
import Exporthk3 from "@/components/Paparexport/exporthk3";
import Exporthk4 from "@/components/Paparexport/exporthk4";
import Exporthk5 from "@/components/Paparexport/exporthk5";
import Exporthk6 from "@/components/Paparexport/exporthk6";
import Exporthk7 from "@/components/Paparexport/exporthk7";
import Exporthk8 from "@/components/Paparexport/exporthk8";
// import ExportPER9 from "@/components/Paparexport/exportPER9";
// import Exportperbelanjaan from "@/components/Paparexport/exportperbelanjaan";
import Exportfoodwaste from "@/components/Paparexport/exportfoodwaste.vue";


export default {
  Name: "Pamerdatahies",
  components: {
    Exportblok3,
    Exportbatch,
    Exportjr2,
    Exportjr5,
    Exportjre,
    Exportblk4a,
    Exportblk4b,
    Exportblk4c,
    Exportblk7imbgan,
    Exporthk1,
    Exporthk2,
    Exporthk3,
    Exporthk4,
    Exporthk5,
    Exporthk6,
    Exporthk7,
    Exporthk8,
    // ExportPER9,
    // Exportperbelanjaan,
    Exportfoodwaste,
  },
  computed: {},
  setup() {},
  data: () => ({
    exportthn: "",
    exportbln: "",
    exportps: '',
    exportneg: '',
    papardatakosong: true,
    snackbar: "",
    headers: [
          {
            text: 'Data Export'
          }
        ],
    item: [
      {
        text: i18n.t("utama"),
        disabled: false,
        href: `paparanutama`,
      },
      {
        text: `${i18n.t("papardataekport")}`,
        disabled: true,
        href: "",
      },
    ],
    title: "",
    jadual: [
      {
        // 00
        nama: `${i18n.t("blok3")}`,
        table: `blok3`,
      },
      {
        // 01
        nama: `${i18n.t("batch")}`,
        table: `batch`,
      },
      {
        // 02
        nama: `${i18n.t("jr2")}`,
        table: `jr2`,
      },
      {
        // 03
        nama: `${i18n.t("jr5")}`,
        table: `jr5`,
      },
      {
        // 04
        nama: `${i18n.t("jre")}`,
        table: `jre`,
      },
      {
        // 05
        nama: `${i18n.t("blk4a")}`,
        table: `blk4a`,
      },
      {
        // 06
        nama: `${i18n.t("blk4b")}`,
        table: `blk4b`,
      },
      {
        // 07
        nama: `${i18n.t("blk4c")}`,
        table: `blk4c`,
      },
      {
        // 08
        nama: `${i18n.t("blk7imbgn")}`,
        table: `blk7imbgn`,
      },
      {
        // 09
        nama: `${i18n.t("hk1")}`,
        table: `hk1`,
      },
      {
        // 10
        nama: `${i18n.t("hk2")}`,
        table: `hk2`,
      },
      {
        // 11
        nama: `${i18n.t("hk3")}`,
        table: `hk3`,
      },
      {
        // 12
        nama: `${i18n.t("hk4")}`,
        table: `hk4`,
      },
      {
        // 13
        nama: `${i18n.t("hk5")}`,
        table: `hk5`,
      },
      {
        // 14
        nama: `${i18n.t("hk6")}`,
        table: `hk6`,
      },
      {
        // 15
        nama: `${i18n.t("hk7")}`,
        table: `hk7`,
      },
      {
        // 16
        nama: `${i18n.t("hk8")}`,
        table: `hk8`,
      },
      // {
      //   // 17
      //   nama: `${i18n.t("per9")}`,
      //   table: `PER9`,
      // },
      // {
      //   // 18
      //   nama: `${i18n.t("perbelanjaan")}`,
      //   table: `PERBELANJAAN`,
      // },
      {
        // 19
        nama: `${i18n.t("FoodWaste")}`,
        table: `FoodWaste`,
      },
    ],
    lookupnegeri: [],
    paparjadual: "",
    lookuppusingan: [],
    paparexportblok3: false,
    paparexportbatch: false,
    paparexportjr2: false,
    paparexportjr5: false,
    paparexportjre:false,
    paparexportblk4a: false,
    paparexportblk4b:false,
    paparexportblk4c:false,
    paparexportblk7imbgan:false,
    paparexporthk1:false,
    paparexporthk2: false,
    paparexporthk3: false,
    paparexporthk4: false,
    paparexporthk5: false,
    paparexporthk6: false,
    paparexporthk7: false,
    paparexporthk8: false,
    // paparexportPER9: false,
    // paparexportperbelanjaan: false,
    paparexportfoodwaste: false,
    papardatablk3: [],
    papardatabatch: [],
    papardatajr2:[],
    papardatajr5: [],
    //papardataj5:[],
    papardatajre: [],
    papardatablk4a:[],
    papardatablk4b:[],
    papardatablk4c:[],
    papardatablk7imbgn:[],
    papardatahk1:[],
    papardatahk2: [],
    papardatahk3: [],
    papardatahk4: [],
    papardatahk5: [],
    papardatahk6: [],
    papardatahk7: [],
    papardatahk8: [],
    // papardataPER9: [],
    // papardataperbelanjaan: [],
    papardatafoodwaste: [],
    paparnegeriexport: "",
    paparpusinganexport: "",
    disablepusingan: true,
    peranan: "",
    disablenegeri: true,
    disablejadual:true,
  }),
  mounted() {
    this.$store.dispatch("localStorageuser");
    this.permulaan();
    // let a = '0123456789'
    // console.log(console.log(a.substring(0, 3)))
  },
  methods: {
    goToRoute(url) {
      return `/${i18n.locale}/${url}`;
    },
    async permulaan() {
      this.peranan = this.$store.state.localStorageuser.role;
      this.paparnegeriexport = this.$store.state.localStorageuser.kodneg;
      let negeri = await negerilookup.getNegeri();
      let role = ["PP", "PO", "FE", "RESPONDENT"]
      this.disablenegeri =
      role.includes(this.peranan) === true
          ? true
          : false;
      this.disablejadual = role.includes(this.peranan) !== true
          ? true
          : false;
      const Negeri = [];
      negeri.data.data.forEach(async function (element) {
        if ((element.negeri !== "Admin") && (element.negeri !== "Responden")) {
          Negeri.push({
            negeriID: `${element.negeriID}`,
            negeri: `${element.negeri}`,
          });
        }
      });
      this.lookupnegeri = Negeri
    },
    async paparlookupjadual(){
      this.disablejadual = false
      this.paparjadual = ''
      this.paparpusinganexport = ''
      this.paparjadualexport()
      this.papardatakosong = true
    },
    async paparexport() {
      this.papardatablk3 = []
      this.papardatabatch = []
      this.papardatajr2 = []
      this.papardatajr5 = []
      //this.papardataj5 = []
      this.papardatajre = []
      this.papardatablk4a = []
      this.papardatablk4b=[]
      this.papardatablk4c=[]
      this.papardatablk7imbgn = []
      this.papardatahk1 = []
      this.papardatahk2 = []
      this.papardatahk3 = []
      this.papardatahk4 = []
      this.papardatahk5 = []
      this.papardatahk6 = []
      this.papardatahk7 = []
      this.papardatahk8 = []
      // this.papardataPER9 = []
      // this.papardataperbelanjaan = []
      this.papardatafoodwaste = []
      this.paparjadualexport()
      // var res = await pusingan.getPusinganData();
      var res = await pusingan.getPusinganData();
      var listPusinganAll = res.data.data;
      
      //console.log(listPusinganAll)
      this.lookuppusingan = listPusinganAll;
      this.lookuppusingan.push({"id":"ALL","pusingan":"ALL","bulan":"ALL","tahun":"2024"})
      this.paparpusinganexport = ''

      switch (this.paparjadual.table) {
        case this.jadual[0].table:
          this.paparexportblok3 = true;
          this.title = i18n.t(this.jadual[0].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[1].table:
          this.paparexportbatch = true;
          this.title = i18n.t(this.jadual[1].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[2].table:
          this.paparexportjr2 = true;
          this.title = i18n.t(this.jadual[2].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[3].table:
          this.paparexportjr5 = true;
          this.title = i18n.t(this.jadual[3].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[4].table:
          this.paparexportjre = true;
          this.title = i18n.t(this.jadual[4].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[5].table:
          this.paparexportblk4a = true;
          this.title = i18n.t(this.jadual[5].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[6].table:
          this.paparexportblk4b = true;
          this.title = i18n.t(this.jadual[6].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[7].table:
          this.paparexportblk4c = true;
          this.title = i18n.t(this.jadual[7].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[8].table:
          this.paparexportblk7imbgan = true;
          this.title = i18n.t(this.jadual[8].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[9].table:
          this.paparexporthk1 = true;
          this.title = i18n.t(this.jadual[9].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[10].table:
          this.paparexporthk2 = true;
          this.title = i18n.t(this.jadual[10].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[11].table:
          this.paparexporthk3 = true;
          this.title = i18n.t(this.jadual[11].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[12].table:
          this.paparexporthk4 = true;
          this.title = i18n.t(this.jadual[12].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[13].table:
          this.paparexporthk5 = true;
          this.title = i18n.t(this.jadual[13].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[14].table:
          this.paparexporthk6 = true;
          this.title = i18n.t(this.jadual[14].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[15].table:
          this.paparexporthk7 = true;
          this.title = i18n.t(this.jadual[15].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        case this.jadual[16].table:
          this.paparexporthk8 = true;
          this.title = i18n.t(this.jadual[16].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
        // case this.jadual[17].table:
        //   this.paparexportPER9 = true;
        //   this.title = i18n.t(this.jadual[17].table);
        //   // this.pusingancustom();
        //   this.disablepusingan = false;
        //   this.papardatakosong = false
        //   break;
        // case this.jadual[18].table:
        //   this.paparexportperbelanjaan = true;
        //   this.title = i18n.t(this.jadual[18].table);
        //   // this.pusingancustom();
        //   this.disablepusingan = false;
        //   this.papardatakosong = false
        //   break;
        case this.jadual[17].table:
          this.paparexportfoodwaste = true;
          this.title = i18n.t(this.jadual[17].table);
          // this.pusingancustom();
          this.disablepusingan = false;
          this.papardatakosong = false
          break;
      }
    },
    async paparjadualexport(){
      this.paparexportblok3 = false;
      this.paparexportbatch = false;
      this.paparexportjr2 = false;
      this.paparexportjr5 = false;
      this.paparexportjre = false;
      this.paparexportblk4a = false;
      this.paparexportblk4b = false;
      this.paparexportblk4c = false;
      this.paparexportblk7imbgan = false;
      this.paparexporthk1 = false;
      this.paparexporthk2 = false;
      this.paparexporthk3 = false;
      this.paparexporthk4 = false
      this.paparexporthk5 = false;
      this.paparexporthk6 = false
      this.paparexporthk7 = false
      this.paparexporthk8 = false
      // this.paparexportPER9 = false
      // this.paparexportperbelanjaan = false
      this.paparexportfoodwaste = false
      this.papardatakosong = true
    },
    async cari() {
      switch (this.paparjadual.table) {
        case this.jadual[0].table:
          axios
            .post(
              `${process.env.VUE_APP_API_URL}/blk/caridatablok3brdasarknpusingan`,
              {
                bulan: this.paparpusinganexport.bulan,
                tahun: this.paparpusinganexport.tahun,
                pusingan: this.paparpusinganexport.pusingan,
                negeri: this.paparnegeriexport
              }
            )
            .then((response) => {
              this.papardatablk3 = response.data.blok3;
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
        case this.jadual[1].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/batch/papardataexportbatch`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatabatch = response.data.paparbatch;
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
        case this.jadual[2].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/JR/paparsemuadatajr2export`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatajr2 = response.data.paparjr2;
              console.log(this.papardatajr2)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[3].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/JR5/papardataexportjr5`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatajr5 = response.data.paparjr5;
              console.log(this.papardatajr5)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[4].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/JRE/paparexportdatajre`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatajre = response.data.Jre;
              console.log(this.papardatajre)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[5].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/blk/paparexportblk4A`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatablk4a = response.data.Blok4A;
              console.log(this.papardatablk4a)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[6].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/blk/paparexportblk4B`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatablk4b = response.data.Blok4B;
              console.log(this.papardatablk4b)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[7].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/blk/paparexportblk4C`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatablk4c = response.data.Blok4C;
              console.log(this.papardatablk4c)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[8].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/blk/papardataexportblk7imbgn`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatablk7imbgn = response.data.Blok7imbgan;
              console.log(this.papardatablk7imbgn)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[9].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/HK/papardataexporthk1`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatahk1 = response.data.Hk1;
              console.log(this.papardatahk1)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[10].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/HK/paparexporthk2`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatahk2 = response.data.hk2;
              console.log(this.papardatahk2)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[11].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/HK/paparexporthk3`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatahk3 = response.data.hk3;
              console.log(this.papardatahk3)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[12].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/HK/paparexporthk4`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatahk4 = response.data.hk4;
              console.log(this.papardatahk4)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[13].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/HK/paparexporthk5`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatahk5 = response.data.hk5;
              console.log(this.papardatahk5)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[14].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/HK/paparexporthk6`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatahk6 = response.data.hk6;
              console.log(`this.papardatahk6`)
              console.log(this.papardatahk6)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[15].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/HK/paparexporthk7`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatahk7 = response.data.hk7;
              console.log(`this.papardatahk6`)
              console.log(this.papardatahk7)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[16].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/HK/paparexporthk8`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatahk8 = response.data.hk8;
              console.log(`this.papardatahk8`)
              console.log(this.papardatahk8)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;
          case this.jadual[17].table:
          axios
            .post(`${process.env.VUE_APP_API_URL}/HK/papardataexportfoodwaste`, {
              bulan: this.paparpusinganexport.bulan,
              tahun: this.paparpusinganexport.tahun,
              pusingan: this.paparpusinganexport.pusingan,
              negeri: this.paparnegeriexport
            })
            .then((response) => {
              this.papardatafoodwaste = response.data.foodwaste;
              console.log(this.papardatafoodwaste)
              this.exportthn = this.paparpusinganexport.tahun
              this.exportbln = this.paparpusinganexport.bulan
              this.exportps = this.paparpusinganexport.pusingan
              this.exportneg = this.paparnegeriexport
            });
          break;

          
          // case this.jadual[17].table:
          // axios
          //   .post(`${process.env.VUE_APP_API_URL}/PER9/paparsemuadataper9export`, {
          //     bulan: this.paparpusinganexport.bulan,
          //     tahun: this.paparpusinganexport.tahun,
          //     pusingan: this.paparpusinganexport.pusingan,
          //     negeri: this.paparnegeriexport
          //   })
          //   .then((response) => {
          //     this.papardataPER9 = response.data.PER9;
          //     console.log(`this.papardataPER9`)
          //     console.log(this.papardataPER9)
          //     this.exportthn = this.paparpusinganexport.tahun
          //     this.exportbln = this.paparpusinganexport.bulan
          //     this.exportps = this.paparpusinganexport.pusingan
          //     this.exportneg = this.paparnegeriexport
          //   });
          // break;
          // case this.jadual[18].table:
          // axios
          //   .post(`${process.env.VUE_APP_API_URL}/PER9/paparsemuadataperbelanjaanexport`, {
          //     bulan: this.paparpusinganexport.bulan,
          //     tahun: this.paparpusinganexport.tahun,
          //     pusingan: this.paparpusinganexport.pusingan,
          //     negeri: this.paparnegeriexport
          //   })
          //   .then((response) => {
          //     this.papardataperbelanjaan = response.data.PERBELANJAAN;
          //     console.log(`this.papardataperbelanjaan`)
          //     console.log(this.papardataperbelanjaan)
          //     this.exportthn = this.paparpusinganexport.tahun
          //     this.exportbln = this.paparpusinganexport.bulan
          //     this.exportps = this.paparpusinganexport.pusingan
          //     this.exportneg = this.paparnegeriexport
          //   });
          // break;
      }
    },
  },
};
</script>